"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressInput = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const js_api_loader_1 = require("@googlemaps/js-api-loader");
const utils_1 = require("../../lib/utils");
const select_input_1 = require("./select-input");
const text_input_1 = __importDefault(require("./text-input"));
const formatted_input_1 = __importDefault(require("./formatted-input"));
const findAddressComponent = (addressComponents, targetComponentName, fieldName) => {
    const foundComponent = addressComponents.find((addrComp) => addrComp.types.includes(targetComponentName));
    return foundComponent ? foundComponent[fieldName] : undefined;
};
const StyledInput = styled_components_1.default(text_input_1.default) `
  margin-bottom: 8px;
`;
const StyledSelectInput = styled_components_1.default(select_input_1.NativeSelectInput) `
  margin-bottom: 8px;
  width: 50%;
  float: left;
  padding-right: 9px;
`;
const PostalCodeInput = styled_components_1.default(formatted_input_1.default) `
  margin-bottom: 8px;
  width: 50%;
  float: right;
  padding-left: 9px;
`;
const AddressInput = (_a) => {
    var _b, _c, _d, _e;
    var { apiKey = 'AIzaSyA9-owzemh3TA1HbkM-BBlxqy44QtMN-D4', autocomplete = true, cityError = false, cityHint, cityId = 'city', cityLabel = 'City', cityPlaceholder = 'City', cityRef, countries = ['us'], disabled, locale = 'en', onAutocompleteOptionClick = utils_1.noop, onBlur, onChange = utils_1.noop, onFieldTouch = utils_1.noop, onFocus, postalCodeError = false, postalCodeFormat = '00000', postalCodeHint, postalCodeId = 'postal-code', postalCodeLabel = 'Postal Code', postalCodePlaceholder = 'Postal Code', postalCodeRef, regionError = false, regionHint, regionId = 'region', regionLabel = 'State', regionOptions = [], regionRef, streetAddressError = false, streetAddressHint, streetAddressId = 'street-address', streetAddressLabel = 'Street Address', streetAddressPlaceholder = 'Street Address', streetAddressRef } = _a, props = __rest(_a, ["apiKey", "autocomplete", "cityError", "cityHint", "cityId", "cityLabel", "cityPlaceholder", "cityRef", "countries", "disabled", "locale", "onAutocompleteOptionClick", "onBlur", "onChange", "onFieldTouch", "onFocus", "postalCodeError", "postalCodeFormat", "postalCodeHint", "postalCodeId", "postalCodeLabel", "postalCodePlaceholder", "postalCodeRef", "regionError", "regionHint", "regionId", "regionLabel", "regionOptions", "regionRef", "streetAddressError", "streetAddressHint", "streetAddressId", "streetAddressLabel", "streetAddressPlaceholder", "streetAddressRef"]);
    const [addressValuesState, setAddressValuesState] = react_1.default.useState(props.defaultAddressValues
        ? props.defaultAddressValues
        : {
            streetAddress: '',
            city: '',
            region: '',
            postalCode: '',
        });
    // The ref to the street address field is required to enhance it as a Google Places Autocomplete
    // If the ref is already provided, use that. Otherwise, use this internal ref.
    const internalStreetAddressRef = react_1.default.useRef(null);
    const resolvedStreetAddressRef = streetAddressRef || internalStreetAddressRef;
    react_1.useEffect(() => {
        if (props.addressValues) {
            setAddressValuesState(props.addressValues);
        }
    }, [props.addressValues]);
    const updateAddress = (newAddress) => {
        setAddressValuesState(newAddress);
        if (onChange) {
            onChange(newAddress);
        }
    };
    let googleAutocomplete;
    const fillInAddress = () => {
        var _a;
        // Get the place details from the autocomplete object.
        const { address_components: addressComponents } = googleAutocomplete.getPlace();
        onAutocompleteOptionClick(addressComponents || []);
        if (addressComponents) {
            const postalCode = findAddressComponent(addressComponents, 'postal_code', 'short_name') ||
                '';
            const city = findAddressComponent(addressComponents, 'locality', 'short_name') ||
                findAddressComponent(addressComponents, 'sublocality_level_1', 'short_name') ||
                findAddressComponent(addressComponents, 'sublocality', 'short_name') ||
                '';
            const region = findAddressComponent(addressComponents, 'administrative_area_level_1', 'short_name') || '';
            const streetAddressField = (_a = resolvedStreetAddressRef) === null || _a === void 0 ? void 0 : _a.current;
            const streetAddress = streetAddressField === null || streetAddressField === void 0 ? void 0 : streetAddressField.value.split(',')[0].trim();
            updateAddress({
                streetAddress,
                city,
                region,
                postalCode,
            });
        }
    };
    const loadAutocomplete = (google) => {
        var _a;
        if (!autocomplete) {
            return;
        }
        const streetAddressField = (_a = resolvedStreetAddressRef) === null || _a === void 0 ? void 0 : _a.current;
        if (streetAddressField) {
            googleAutocomplete = new google.maps.places.Autocomplete(streetAddressField, {
                componentRestrictions: { country: countries },
                fields: ['address_components', 'geometry'],
                types: ['address'],
            });
        }
        googleAutocomplete.addListener('place_changed', fillInAddress);
    };
    react_1.useEffect(() => {
        const loader = new js_api_loader_1.Loader({
            apiKey,
            version: 'weekly',
            language: locale,
            libraries: ['places'],
        });
        loader.load().then((google) => {
            loadAutocomplete(google);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleChangeRegion = (e) => {
        const { name, value } = e.target;
        updateAddress(Object.assign(Object.assign({}, addressValuesState), { [name]: value }));
    };
    const handleChange = (value, e) => {
        const { name } = e.target;
        updateAddress(Object.assign(Object.assign({}, addressValuesState), { [name]: value }));
    };
    const handlePostalCodeChange = (value) => {
        updateAddress(Object.assign(Object.assign({}, addressValuesState), { postalCode: value }));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledInput, { ariaLabel: streetAddressLabel, disabled: disabled, onChange: handleChange, value: ((_b = props.addressValues) === null || _b === void 0 ? void 0 : _b.streetAddress) || addressValuesState.streetAddress, name: "streetAddress", id: streetAddressId, label: streetAddressLabel, error: streetAddressError, hint: streetAddressHint, innerRef: resolvedStreetAddressRef, placeholder: streetAddressPlaceholder, onFocus: onFocus, onBlur: onBlur, onKeyDown: onFieldTouch }),
        react_1.default.createElement(StyledInput, Object.assign({}, props, { label: cityLabel, onChange: handleChange, value: ((_c = props.addressValues) === null || _c === void 0 ? void 0 : _c.city) || addressValuesState.city, name: "city", disabled: disabled, hint: cityHint, id: cityId, error: cityError, innerRef: cityRef, placeholder: cityPlaceholder, onFocus: onFocus, onBlur: onBlur, onKeyDown: onFieldTouch })),
        react_1.default.createElement("div", null,
            react_1.default.createElement(StyledSelectInput, Object.assign({ label: regionLabel, value: ((_d = props.addressValues) === null || _d === void 0 ? void 0 : _d.region) || addressValuesState.region, onChange: handleChangeRegion, name: "region", disabled: disabled, hint: regionHint, id: regionId, error: regionError, innerRef: regionRef, onFocus: onFocus, onBlur: onBlur, onClick: onFieldTouch }, props), regionOptions &&
                regionOptions.map((option) => (react_1.default.createElement("option", { value: option.value, key: `option-${option.value}`, disabled: option.value === '' }, option.label)))),
            react_1.default.createElement(PostalCodeInput, Object.assign({}, props, { label: postalCodeLabel, onChange: handlePostalCodeChange, value: ((_e = props.addressValues) === null || _e === void 0 ? void 0 : _e.postalCode) || addressValuesState.postalCode, name: "postalCode", disabled: disabled, hint: postalCodeHint, id: postalCodeId, error: postalCodeError, customFormat: postalCodeFormat, innerRef: postalCodeRef, placeholder: postalCodePlaceholder, onFocus: onFocus, onBlur: onBlur, onKeyDown: onFieldTouch })))));
};
exports.AddressInput = AddressInput;
exports.default = exports.AddressInput;
